import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {from} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {BaseFieldType} from 'compob2b-libs';

@Component({
    templateUrl: './select-lazy.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SelectLazyComponent extends BaseFieldType implements OnInit {
  selOptions: any[] = [];
  buffer: any[] = [];
  bufferSize = 50;
  numberOfItemsFromEndBeforeFetchingMore = 10;

  ngOnInit() {
    this.loading = true;

    from(this.field.templateOptions.options)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(items => {
          this.selOptions = items;
          this.buffer = this.selOptions.slice(0, this.bufferSize);
          this.loading = false;
          this.cdr.detectChanges();
        }
      );
  }

  onScrollToEnd() {
    this.fetchMore();
  }

  onScroll({end}) {
    if (this.loading || this.selOptions.length <= this.buffer.length) {
      return;
    }

    if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.buffer.length) {
      this.fetchMore();
    }
  }

  private fetchMore() {
    const len = this.buffer.length;
    const more = this.selOptions.slice(len, this.bufferSize + len);
    this.loading = false;
    this.buffer = this.buffer.concat(more);
  }

}
